export enum AttachmentModificationType {
  Clone = 0,
  Replace = 1,
  CloneEditMode = 2,
  ReplaceEditMode = 3,
}

export enum DeleteType {
  ConsumerJobAttachments = 1,
  ProviderProfileAttachments = 2,
  ProviderProfilePicture = 3,
  ProviderProfileVideo = 4,
  LicenseOrInsuranceDocuments = 6,
  InspectionReportTemplateAttachments = 8,
}

export enum AttachmentFileTypes {
  Images,
  Videos,
  Email,
  Pdf,
  Other,
  Excel,
  ScannedImages
}

export enum ConfidenceLevel {
  Low = 1,
  Medium = 2,
  High = 3,
}
